import { Button, Form, Input } from 'antd'
import { FC } from 'react'
import { relayStore } from '../store/relay'
import { useNavigate } from 'react-router-dom'
import { RNRelayType, RNRelay } from '../helpers/routeNames'
import { PageBreadcrumb } from '../components/PageBreadcrumb'

export const CreateRelayType: FC = () => {
	const [form] = Form.useForm()
	const { createRelayType } = relayStore()
	const navigate = useNavigate()

	const handleSubmit = (values: any) => {
		createRelayType(values)
		navigate(RNRelayType)
	}

	return (
		<div>
			<PageBreadcrumb
				items={[
					{ label: 'Реле', path: RNRelay },
					{ label: 'Создать тип реле' }
				]}
			/>
			<header>
				<h1>Создать тип реле</h1>
			</header>
			<main>
				<Form onFinish={handleSubmit} form={form}>
					<Form.Item
						label="Name"
						name="name"
						rules={[{ required: true }]}>
						<Input />
					</Form.Item>
					<Form.Item>
						<Button htmlType="submit">Создать</Button>
					</Form.Item>
				</Form>
			</main>
		</div>
	)
}
